module.exports = __webpack_public_path__ + "static/media/careers-hero.76dfe8c7.png";